import { prepareFormToSubmit } from 'UI/utils/forms';

import { FORM_FIELDS_MAP } from '../../forms/TaskResults/TaskResults.constants';

export const formatRegularTaskData = ({ formData }) =>
  prepareFormToSubmit(formData, FORM_FIELDS_MAP);
